import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, skip } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { cloneDeep } from 'lodash-es';
import { BaseObject } from '@shared/base/base-object';
import { SettingsService } from '@api/settings.service';
import { ApiService } from '@api/api.service';

export enum DeferActionEnum {
  Routing = 'Routing',
  DownloadProduct = 'DownloadProduct',
  DownloadFiles = 'DownloadFiles',
}

export interface DeferAction {
  type: DeferActionEnum;
  url?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppState extends BaseObject {
  public leftMenuState$ = new BehaviorSubject<'open' | 'close'>('close');
  public deferActions$ = new BehaviorSubject<DeferAction[]>(null);

  constructor(
    private settingsService: SettingsService,
    private apiService: ApiService,
    private router: Router,
  ) {
    super();

    this.deferActions$
      .pipe(skip(1), takeUntil(this.destroy$))
      .subscribe((result) => localStorage.setItem('deferActions', JSON.stringify(result)));
  }

  public deferActionsHandler(): void {
    const deferActions: DeferAction[] = JSON.parse(localStorage.getItem('deferActions'));
    const actions = cloneDeep(deferActions);

    if (actions?.length) {
      for (let i = 0; i < actions.length; i++) {
        deferActions.shift();

        const url = `${this.settingsService.v2}${actions[i].url}`;

        if (actions[i].type === 'Routing') {
          this.deferActions$.next(deferActions);
          this.router.navigateByUrl(url);
          break;
        }

        if (actions[i].type === 'DownloadFiles') {
          this.apiService.downloadFiles(url);
        }
      }

      this.deferActions$.next(deferActions);
    }
  }
}
